import React, { useState, useEffect, useRef } from 'react';
import { Row, Col, Input, Select, Divider, Table, Image, Button, Modal, Form, Checkbox, Spin, Progress, notification } from 'antd';
import { PlusOutlined, SaveOutlined, FileAddOutlined, SyncOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { useNavigate, useParams } from 'react-router-dom';
import { fetchData, sendData } from '../../httpRequests';
import { getPharmacyId } from '../../components/Shared';
import ExportJsonExcel from 'js-export-excel'

import * as XLSX from "xlsx"

const { Search } = Input;
const { Option } = Select;
const antIcon = <SyncOutlined style={{ fontSize: 50, color: '#128780' }} spin />;
export default function AdminPharmacyProducts() {
	const { id } = useParams();
	const navigate = useNavigate();
	const [categories, setCategories] = useState([]);
	const [products, setProducts] = useState([]);
	const [filteredProducts, setFilteredProducts] = useState([]);
	const [selectedProduct, setSelectedProduct] = useState({});
	const [showProductModal, setShowProductModal] = useState(false);
	const [isModalVisibleCreateProductList, setIsModalVisibleCreateProductList] = useState(false);
	const [fileSeleted, setFileSeleted] = useState('')
	const [nameFile, setNameFile] = useState('')
	const [isLoading, setIsLoading] = useState(false);
	const [initPorcent, setInitPorcent] = useState(0);
	const [tbLoading, setTbLoading] = useState(false)

	useEffect(() => {
		loadCategories();
	}, []);

	const loadCategories = () => {
		checkUserAdmin(getPharmacyId());

		let url = '/categories/getCategories';
		fetchData(url).then((response) => {
			if (Object.keys(response).length > 0) {
				const categories = response['category'];
				setCategories(categories);
				setIsModalVisibleCreateProductList(false)
				loadPharmacyProducts(categories);
			}
		});
	};

	const loadPharmacyProducts = (categories) => {
		setTbLoading(true)
		const url = '/products/getProductsByPharmacyPanel';
		const data = {
			pharmacy_id: id
		};
		sendData(url, data).then((response) => {
			if (Object.keys(response).length > 0) {
				const products = response['pharmacyproduct'];
				products.map((product) => {
					if (product.product_category_id) {
						const category = categories.find((category) => product.product_category_id == category.id);
						product.product_category = category.name;
					} else {
						product.product_category = 'Not defined';
					}
				});
				setProducts(products);
				setFilteredProducts(products);
				setTbLoading(false)
			}
			setTbLoading(false)
		});

	};

	const checkUserAdmin = (pharmacyId) => {
		const url = '/pharmacies/getPharmacyById';
		const data = {
			id: pharmacyId
		};
		sendData(url, data).then((response) => {
			const pharmacy = response['pharmacy'];
			if (pharmacy.role_id != 4&&pharmacy.role_id!=5) navigate('/orders');
		});

		return false;
	};

	const onSearch = (value) => {
		const text = value.target.value;

		if (text) {
			const filteredProducts = products.filter((product) => product.product_name.toUpperCase().includes(text.toUpperCase()));
			setFilteredProducts(filteredProducts);
		} else {
			setFilteredProducts(products);
		}

	};

	const handleChangeStatus = (value) => {
		if (value) {
			const status = (value == 1 && value) || 0;
			const filteredProducts = products.filter((product) => product.status == status);
			setFilteredProducts(filteredProducts);
		} else {
			setFilteredProducts(products);
		}
	};

	const handleChangeCategory = (value) => {
		if (value) {
			const category = categories.find((category) => category.id == value);
			const filteredProducts = products.filter((product) => product.product_category_id == category.id);
			setFilteredProducts(filteredProducts);
		} else {
			setFilteredProducts(products);
		}
	};

	const openProductModal = (product) => {
		setSelectedProduct(product);
		setShowProductModal(true);
	};

	const closeProductModal = () => {
		setShowProductModal(false);
		loadCategories();
	};

	const columns = [
		{
			title: '',
			render: ({ product_img }) => (
				<div
					style={{
						width: 40
					}}
				>
					<Image src={product_img ? product_img : "http://openmart.online/frontend/imgs/no_image.png?v=1"} />
				</div>
			)
		},
		{
			title: 'Name',
			dataIndex: 'product_name',
			key: 'product_name',
			defaultSortOrder: 'ascend',
			sorter: (a, b) => a.product_name.localeCompare(b.product_name)
		},
		{ title: 'Category', dataIndex: 'product_category', key: 'product_category_id' },
		{
			title: 'Price',
			render: ({ price }) => <span>${price}</span>,
			key: 'price'
		},
		{ title: 'Quantity', dataIndex: 'stock', key: 'stock' },
		{
			title: 'Status',
			render: ({ status }) => {
				return <span>{(status == 1 && 'Active') || 'Inactive'}</span>;
			},
			key: 'status'
		}
	];

	const showModalCreateProductList = () => {
		setIsModalVisibleCreateProductList(true);
	};
	const handleOkFile = () => {
		setIsModalVisibleCreateProductList(false);
	};

	const handleCancelFile = () => {
		setIsModalVisibleCreateProductList(false);
	};
	const saveProductFile = async () => {

		// inti file
		setIsLoading(true)
		const promise = new Promise((resolve, reject) => {
			const fileReader = new FileReader();

			fileReader.readAsArrayBuffer(fileSeleted);

			fileReader.onload = (e) => {
				const bufferArray = e.target.result;

				const wb = XLSX.read(bufferArray, { type: "buffer" });

				const wsname = wb.SheetNames[0];

				const ws = wb.Sheets[wsname];

				const data = XLSX.utils.sheet_to_json(ws);

				resolve(data)
			};

			fileReader.onerror = (error) => {
				reject(error)
				setIsLoading(false)
			};
		});

		promise.then(async (d) => {
			// console.log(d, "d")
			let init = 0
			let fin = 0
			let entrada = []
			let total = Math.floor(d.length / 5)
			// console.log(total, 'total')

			for (let i = 0; i <= total; i++) {
				init = i * 5
				fin = fin + 5
				entrada.push(d.slice(init, fin))
			}

			for (let i in entrada) {
				let response = await sendData(`/pharmacies/cargaMasiva/${id}`, entrada[i])
				if (response.ok) {
					// console.log('bien', init)
					setInitPorcent(Math.round((i / entrada.length) * 5))
					// console.log(initPorcent,"initPorcent")
					if (i == entrada.length - 1) {
						setIsLoading(false)
						loadCategories()
						openNotificationWithIcon('success', 'product added successfully')
						setIsModalVisibleCreateProductList(false)
					}
				} else {
					if (i == entrada.length - 1) {
						openNotificationWithIcon('warning', 'This file does not meet the requirements.')
						openNotificationWithIcon('warning', 'an error has occurred contact the administrator.')
						setIsModalVisibleCreateProductList(false)
					}

				}
			}
			setInitPorcent(0)
		})
	}
	const exportExcel = () => {
		let option = {};
		option.fileName = 'Copharma'; // nombre de archivo
		// name price quantity upc
		option.datas = [
			{
				sheetData: [
					// { one: "name", two: "upc", three: "quantity", four:"price" },

				],// datos
				sheetName: 'Copharma', // nombre de la hoja
				sheetFilter: ['two', 'one', 'three', 'four'], // filtrado de columna
				sheetHeader: ['name', 'upc', 'quantity', 'price'], // encabezado de la primera fila
				// columnWidths: [20, 20] // el ancho de la columna debe corresponder al orden de la columna
			},
			// varias tablas

		];

		const toExcel = new ExportJsonExcel(option); //new
		toExcel.saveExcel(); // Guardar

	}

	const readExcel = (file) => {
		if (file == '' || file == null || file == undefined) {
			setNameFile('')
			setFileSeleted('')
		} else {
			setNameFile(file.name)
			setFileSeleted(file)
		}
	}

	const openNotificationWithIcon = (type, mensaje) => {
		notification[type]({
			description: mensaje,
			duration: 10.0
		});
	};


	return (
		<div>
			<Modal title="Add File" visible={isModalVisibleCreateProductList} onOk={handleOkFile} onCancel={handleCancelFile}
				footer={[
					<Button key='back' type='primary' disabled={fileSeleted == ''} onClick={saveProductFile}
						size='large'
						style={{ backgroundColor: '#128780', width: '100%', borderRadius: 5 }}>
						<SaveOutlined />
						save File</Button>
				]}>
				<div onClick={exportExcel} className="clickdowload">Click here to download excel</div>
				<hr />
				<ul>
					<li><strong>Name: </strong> <small>Name of product.</small></li>
					<li><strong>Upc: </strong><small>Universal product code.</small></li>
					<li><strong>Price: </strong><small>Price of product.</small></li>
					<li><strong>Quantity: </strong><small>Quantity of produc.</small></li>
				</ul>
				<hr />
				<div className='bordereFile'>
					<div className='file-select'>
						{/* <div className='close-drap'>
					<CloseCircleOutlined  style={{ fontSize: '20px',color: 'red' }}/>
					</div> */}
						<div className='drag'>
							<div>
								<div style={{ textAlign: 'center' }}>
									<FileAddOutlined style={{ fontSize: '32px', color: 'white' }} />
								</div>
								<div style={{ textAlign: 'center' }}>
									<b style={{ fornSize: '17px', color: 'white' }}>Add File</b>
								</div>
								<p style={{ color: 'white' }}>or drag and drop</p>
							</div>
						</div>
						<input type="file" onChange={(e) => {
							const file = e.target.files[0]
							readExcel(file)
						}} />
					</div>
				</div>
				{
					nameFile == '' ? (<small style={{ color: 'red' }}>No file selected</small>)
						: (<small><span>{nameFile}</span></small>)
				}
				{
					isLoading == true ? (<Col span={24} style={{ textAlign: 'center', padding: '10px' }} >
						<Spin tip="Please Wait This may take a while...." indicator={antIcon}>
						</Spin>
						{/* <div><small><strong>{initPorcent}</strong></small> de <small><strong>100%</strong></small></div> */}
						<Progress
							strokeColor={{
								'0%': '#108ee9',
								'100%': '#87d068',
							}}
							percent={initPorcent}
						/>
					</Col>)
						: (<></>)
				}

			</Modal>
			<ProductModal
				selectedProduct={selectedProduct}
				showProductModal={showProductModal}
				closeProductModal={closeProductModal}
			/>
			<Row gutter={24}>
				<Col span={6}>
					<Search size='large' placeholder='Search product by name' onChange={onSearch} />
				</Col>
				<Col span={5}>
					<Select
						placeholder='Select category'
						defaultValue={''}
						size='large'
						onChange={handleChangeCategory}
						style={{ width: '100%' }}
					>
						<Option value=''>All</Option>
						{categories.map((category) => (
							<Option key={category.id} value={category.id}>
								{category.name}
							</Option>
						))}
					</Select>
				</Col>
				<Col span={5}>
					<Select
						placeholder='Select status'
						defaultValue={''}
						size='large'
						onChange={handleChangeStatus}
						style={{ width: '100%' }}
					>
						<Option value=''>All</Option>
						<Option value={1}>Active</Option>
						<Option value={2}>Inactive</Option>
					</Select>
				</Col>
				<Col span={4}>
					<Button
						onClick={() => navigate('/admin/pharmacyNewProduct/' + id)}
						type='primary'
						size='large'
						style={{ backgroundColor: '#128780', width: '100%', borderRadius: 5 }}
					>
						<PlusOutlined />
						Add Product
					</Button>
				</Col>
				<Col span={4}>

					<Button
						onClick={showModalCreateProductList}
						type='primary'
						size='large'
						style={{ backgroundColor: '#128780', width: '100%', borderRadius: 5 }}
					>
						<PlusOutlined />
						Add List Product 
					</Button>

				</Col>
			</Row>
			<Divider />
			<Row gutter={24}>
				<Col span={24}>
					<Table
						columns={columns}
						dataSource={filteredProducts}
						rowKey={(item) => item.id}
						loading={tbLoading}
						onRow={(record, index) => {
							return {
								onClick: (event) => openProductModal(record)
							};
						}}
					/>
				</Col>
			</Row>
		</div>
	);
}

function ProductModal({ selectedProduct, showProductModal, closeProductModal }) {
	const { id } = useParams();
	const form = useRef(null);
	const [status, setStatus] = useState(false);
	const [gift, setGift] = useState({
		status: false,
		value: 0.0
	});
	const [ivu, setIvu] = useState({
		ivu_est: false,
		ivu_mun: false
	});

	useEffect(() => {
		if (Object.keys(selectedProduct).length > 0) {
			setStatus(selectedProduct.status);
			setGift({
				status: selectedProduct.gift_status,
				value: selectedProduct.gift_status ? selectedProduct.gift_price : 0.0
			});

			setIvu({
				ivu_est: selectedProduct.ivu_statal,
				ivu_mun: selectedProduct.ivu_municipal
			});
		}
	}, [selectedProduct]);

	const changeGiftStatus = (value) => {
		const status = value.target.checked;
		selectedProduct.gift_status = status;
		setGift({
			status: status,
			value: status ? selectedProduct.gift_price : 0.0
		});
	};

	const changeIVUStatus = (target, type) => {
		const status = target.checked;
		if (type == 1) {
			selectedProduct.ivu_statal = status;
			setIvu((prevState) => {
				return {
					...prevState,
					ivu_est: status
				};
			});
		} else {
			selectedProduct.ivu_municipal = status;
			setIvu((prevState) => {
				return {
					...prevState,
					ivu_mun: status
				};
			});
		}
	};

	const handleSubmit = (values) => {
		const url = '/products/updateProductByPharmacy';
		const data = {
			pharmacy_id: id,
			product_id: selectedProduct.product_id,
			stock: Number(values.quantity),
			price: Number(values.price),
			gift_price: Number(values.gift_price),
			gift_status: gift.status ? 1 : 0,
			ivu_statal: ivu.ivu_est ? 1 : 0,
			ivu_municipal: ivu.ivu_mun ? 1 : 0,
			active: status ? 1 : 0
		};
		sendData(url, data).then((response) => {
			if (Object.keys(response).length > 0) {
				closeProductModal();
			}
		});
	};

	return (
		<Modal
			visible={showProductModal}
			onCancel={closeProductModal}
			title={'Product details'}
			width={700}
			footer={[
				<Button key='back' onClick={closeProductModal}>
					Cancel
				</Button>,
				<Button key='submit' type='primary' onClick={() => form.current.submit()}>
					Save
				</Button>
			]}
		>
			<Form
				layout='vertical'
				className='form'
				style={{ width: '100%' }}
				ref={form}
				onLoad={() => form.current.resetFields()}
				onFinish={handleSubmit}
			>
				{Object.keys(selectedProduct).length > 0 && (
					<Row gutter={24}>
						<Col span={8} style={{ justifyContent: 'center', display: 'flex', alignItems: 'center' }}>
							<div
								style={{
									width: 160
								}}
							>
								<Image src={selectedProduct.product_img ? selectedProduct.product_img : "http://openmart.online/frontend/imgs/no_image.png?v=1"} />
							</div>
						</Col>
						<Col span={16}>
							<Row gutter={24}>
								<Col span={12}>
									<Form.Item label='Name' name='name' initialValue={selectedProduct.product_name}>
										<Input size='large' type='name' disabled />
									</Form.Item>
								</Col>
								<Col span={12}>
									<Form.Item
										label='Category'
										name='category'
										initialValue={selectedProduct.product_category}
									>
										<Input size='large' type='text' disabled />
									</Form.Item>
								</Col>
							</Row>
							<Row gutter={24}>
								<Col span={12}>
									<Form.Item label='Quantity' name='quantity' initialValue={selectedProduct.stock}>
										<Input size='large' type='number' />
									</Form.Item>
								</Col>
								<Col span={12}>
									<Form.Item label='Price' name='price' initialValue={selectedProduct.price}>
										<Input size='large' type='number' />
									</Form.Item>
								</Col>
							</Row>
							<Row gutter={24}>
								<Col span={12}>
									<Row gutter={24}>
										<Col span={11}>
											<Form.Item label='State TAX' name='ivu_statal'>
												<Checkbox
													checked={ivu.ivu_est}
													onChange={({ target }) => changeIVUStatus(target, 1)}
												/>
											</Form.Item>
										</Col>
										<Col span={13}>
											<Form.Item label='Municipal TAX' name='ivu_municipal'>
												<Checkbox
													checked={ivu.ivu_mun}
													onChange={({ target }) => changeIVUStatus(target, 2)}
												/>
											</Form.Item>
										</Col>
									</Row>
								</Col>
								<Col span={12}>
									<Row gutter={24}>
										<Col span={5}>
											<Form.Item label='Gift' name='gift_status'>
												<Checkbox checked={gift.status} onChange={changeGiftStatus} />
											</Form.Item>
										</Col>
										<Col span={19}>
											<Form.Item label='Gift Price' name='gift_price' initialValue={gift.value}>
												<Input size='large' type='number' disabled={!gift.status} />
											</Form.Item>
										</Col>
									</Row>
								</Col>
							</Row>
							<Row gutter={24}>
								<Col span={24}>
									<Form.Item label={'Status: ' + ((status > 0 && 'Active') || 'Inactive')}>
										<Button
											type='primary'
											danger={status > 0}
											style={{ borderRadius: 10, width: '100%' }}
											size='large'
											onClick={() => setStatus(!status)}
										>
											{(status == 0 && 'Activate') || 'Desactivate'}
										</Button>
									</Form.Item>
								</Col>
							</Row>
						</Col>
					</Row>
				)}
			</Form>
		</Modal>
	);
}

ProductModal.propTypes = {
	selectedProduct: PropTypes.object,
	showProductModal: PropTypes.bool,
	closeProductModal: PropTypes.func
};
